import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all locale files
import enCommon from './locales/en/common.json';
import enPages from './locales/en/pages.json';
import enLegal from './locales/en/legal.json';
import enBlog from './locales/en/blog.json';
import enEmail from './locales/en/email.json';
import enTutorial from './locales/en/tutorial.json';

import jaCommon from './locales/ja/common.json';
import jaPages from './locales/ja/pages.json';
import jaLegal from './locales/ja/legal.json';
import jaBlog from './locales/ja/blog.json';
import jaEmail from './locales/ja/email.json';
import jaTutorial from './locales/ja/tutorial.json';

import zhCNCommon from './locales/zh-CN/common.json';
import zhCNPages from './locales/zh-CN/pages.json';
import zhCNLegal from './locales/zh-CN/legal.json';
import zhCNBlog from './locales/zh-CN/blog.json';
import zhCNEmail from './locales/zh-CN/email.json';
import zhCNTutorial from './locales/zh-CN/tutorial.json';

import zhTWCommon from './locales/zh-TW/common.json';
import zhTWPages from './locales/zh-TW/pages.json';
import zhTWLegal from './locales/zh-TW/legal.json';
import zhTWBlog from './locales/zh-TW/blog.json';
import zhTWEmail from './locales/zh-TW/email.json';
import zhTWTutorial from './locales/zh-TW/tutorial.json';

import koCommon from './locales/ko/common.json';
import koPages from './locales/ko/pages.json';
import koLegal from './locales/ko/legal.json';
import koBlog from './locales/ko/blog.json';
import koEmail from './locales/ko/email.json';
import koTutorial from './locales/ko/tutorial.json';

import itCommon from './locales/it/common.json';
import itPages from './locales/it/pages.json';
import itLegal from './locales/it/legal.json';
import itBlog from './locales/it/blog.json';
import itEmail from './locales/it/email.json';
import itTutorial from './locales/it/tutorial.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', shortLabel: 'EN' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', shortLabel: 'JA' },
  { code: 'zh-CN', name: 'Chinese (Simplified)', nativeName: '简体中文', shortLabel: '简' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', nativeName: '繁體中文', shortLabel: '繁' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', shortLabel: 'KO' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', shortLabel: 'IT' },
] as const;

export type LanguageCode = typeof SUPPORTED_LANGUAGES[number]['code'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, pages: enPages, legal: enLegal, blog: enBlog, email: enEmail, tutorial: enTutorial },
      ja: { common: jaCommon, pages: jaPages, legal: jaLegal, blog: jaBlog, email: jaEmail, tutorial: jaTutorial },
      'zh-CN': { common: zhCNCommon, pages: zhCNPages, legal: zhCNLegal, blog: zhCNBlog, email: zhCNEmail, tutorial: zhCNTutorial },
      'zh-TW': { common: zhTWCommon, pages: zhTWPages, legal: zhTWLegal, blog: zhTWBlog, email: zhTWEmail, tutorial: zhTWTutorial },
      ko: { common: koCommon, pages: koPages, legal: koLegal, blog: koBlog, email: koEmail, tutorial: koTutorial },
      it: { common: itCommon, pages: itPages, legal: itLegal, blog: itBlog, email: itEmail, tutorial: itTutorial },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    fallbackNS: ['common', 'pages'],
    ns: ['common', 'pages', 'legal', 'blog', 'email', 'tutorial'],
    compatibilityJSON: 'v3',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'tg_language',
      caches: ['localStorage'],
    },
  });

export default i18n;
